import { trackClickUnbookableCTA } from './actions';

export default {
    trackClickUnbookableCTA,
};
